import { render, staticRenderFns } from "./Interviews.vue?vue&type=template&id=2cea8e22&scoped=true"
import script from "./Interviews.vue?vue&type=script&lang=js"
export * from "./Interviews.vue?vue&type=script&lang=js"
import style0 from "./Interviews.vue?vue&type=style&index=0&id=2cea8e22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cea8e22",
  null
  
)

export default component.exports